// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C8io","clinicsSelect":"styles_clinicsSelect__3SH2R"};